import { BehaviorSubject } from 'rxjs';
// import Helpers from "./helpers";

const Storage = {};

let items = {};

let obsrv = {};

const stored_in_memory = {};

const stored_in_browser = [
	"selected_pod",
	"uid",
	// "netflix_popup",
	"paid_online",
	"account_id",
	"customer_id",
	"hashed_email_address",
	"showInternationalModalOnce",
	"delivery_form",
	"delivery_error",
	"selected_store_pickup",
	"selectedCommitment",
	"registration_type",
	"custom_combo",
	"is_resident",
	"order_id",
	"go_to_thank_you",
	"session_email",
	"reached_to_thank_you_page",
	"pixel_purchase_event_called",
	"pixel_payment_page_viewed_event_called",
	"redirectd_to_thank_you"
];

Storage.get_obsrv = setting => {
	if (Object.keys(obsrv).indexOf(setting) === -1) {
		if (Object.keys(items).indexOf(setting) === -1) {
			items[setting] = null;
		}
		obsrv[setting] = new BehaviorSubject(items[setting]);
	}
	return obsrv[setting].asObservable();
};

Storage.get = (setting, look_in_browser_storage = false) => {
	if (Object.keys(items).indexOf(setting) !== -1) {
		return items[setting];
	} else {
		if (look_in_browser_storage) {
			let in_storage = window.localStorage.getItem(setting);
			if (in_storage) {
				return in_storage;
			}
		}
		return null;
	}
};

Storage.set = (setting, val, store_in_browser = false, shared = false) => {
	items[setting] = val;
	if (store_in_browser) {
		window.localStorage.setItem(setting, val);
	}
	if (Object.keys(obsrv).indexOf(setting) === -1) {
		obsrv[setting] = new BehaviorSubject(items[setting]);
	}
	if(!shared){
		stored_in_memory[setting] = true;
	}
	obsrv[setting].next(val);
};

Storage.getAll = () => {
	return items;
}

Storage.setShared = (setting, val, store_in_browser = false) => {
	Storage.set(setting, val, store_in_browser, true);
}

Storage.clear = setting => {
	Storage.set(setting, null);
	if (window.localStorage.getItem(setting)) {
		window.localStorage.removeItem(setting);
	}
};

Storage.wipe = () => {
	for (let setting of stored_in_browser) {
		window.localStorage.removeItem(setting);
	}
	for (let setting of Object.keys(stored_in_memory)) {
		Storage.clear(setting);
	}
}

Storage.getOrfetch = (property, serviceFetcher, force_fetch = false) => {

	if(Storage.get("fetching_" + property)){
		return Storage.get("fetching_" + property);
	}
	
	if (Storage.get(property) && !force_fetch) {
		// Helpers.log("found " + property + " in storage.. ");
		let data = Storage.get(property);
		Storage.set("fetching_" + property, false);
		return new Promise((resolve, reject) => {
			resolve(data);
		});
	} else {
		let f = serviceFetcher();
		Storage.set("fetching_" + property, f);
		// Helpers.log("fetching " + property + " from api..");
		
		f.then(res=>{
			Storage.set("fetching_" + property, false);
		}).catch(err =>{
			Storage.set("fetching_" + property, false);
		});
		return f;
	}
};

export default Storage;